module.exports = __webpack_public_path__ + "img/nowin-icon.752b3ee9.png";